import { FormControl, InputLabel, OutlinedInput, InputAdornment, CircularProgress, IconButton } from '@mui/material'
import { useState, useEffect } from 'react'
import useDebounce from './Debounce'
import BackspaceTwoToneIcon from '@mui/icons-material/BackspaceTwoTone'

interface SearchInputProps {
    initialValue: string
    onSearchChange: (searchTerm: string) => void
    isLoading: boolean
}

function SearchInput({ initialValue, onSearchChange, isLoading }: SearchInputProps) {
    const [inputValue, setInputValue] = useState(initialValue)
    const debouncedSearchTerm = useDebounce({ value: inputValue, delay: 300 })

    useEffect(() => {
        if (debouncedSearchTerm !== initialValue) {
            onSearchChange(debouncedSearchTerm)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchTerm])

    // Sincronizza lo stato interno se il valore iniziale (da Redux) viene resettato dall'esterno
    useEffect(() => {
        if (initialValue !== inputValue) {
            setInputValue(initialValue)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue])

    const handleClear = () => {
        setInputValue('')
        // onClear()
    }

    return (
        <FormControl fullWidth variant="outlined">
            <InputLabel>Ricerca libera</InputLabel>
            <OutlinedInput
                size="medium"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                endAdornment={
                    <InputAdornment position="end">
                        {isLoading && <CircularProgress variant="indeterminate" size="1rem" />}
                        <IconButton color="primary" edge="end" onClick={handleClear}>
                            <BackspaceTwoToneIcon color="secondary" />
                        </IconButton>
                    </InputAdornment>
                }
                inputProps={{
                    autoComplete: 'off',
                    autoCorrect: 'off',
                    autoCapitalize: 'off',
                    spellCheck: 'false',
                }}
                label="Ricerca libera"
                sx={{
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                }}
            />
        </FormControl>
    )
}

export default SearchInput
